// eslint-disable-next-line import/prefer-default-export
export const SCOPE = 'ViewerModule';
export const INIT = `${SCOPE}/INIT`;
export const RESET = `${SCOPE}/RESET`;
export const UPDATE_PERSISTED_VM_STATE = `${SCOPE}/UPDATE_PERSISTED_VM_STATE`;

const types = {
  SET_DATE: `${SCOPE}/SET_DATE`,
  SET_INTERVAL: `${SCOPE}/SET_INTERVAL`,
  SET_ADVANCED: `${SCOPE}/SET_ADVANCED`,
  SET_ROWDATA: `${SCOPE}/SET_ROWDATA`,
  SET_GEODATA: `${SCOPE}/SET_GEODATA`,
  SET_SEARCH_SORT_DATA: `${SCOPE}/SET_SEARCH_SORT_DATA`,
  SET_ENABLESSE: `${SCOPE}/SET_ENABLESSE`,
}

export default types;
